import { render, staticRenderFns } from "./AppVersionTable.vue?vue&type=template&id=52339bd9&scoped=true&"
import script from "./AppVersionTable.vue?vue&type=script&lang=js&"
export * from "./AppVersionTable.vue?vue&type=script&lang=js&"
import style0 from "./AppVersionTable.vue?vue&type=style&index=0&id=52339bd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52339bd9",
  null
  
)

export default component.exports